import Button from "@mui/material/Button";

import Navbar from "./components/navbar/navbar";

import EditMember from "./pages/edit_member";

import Members from "./pages/members";
import UserLogin from "./pages/login";

import Users from "./pages/admin/edit_user/edit_user";

import { Routes, Route, useNavigate } from "react-router-dom";

import Logout from "./pages/logout";
import Kids from "./pages/greenkids/kids";
import Finish from "./pages/finish";

function App() {
  const returnHome = useNavigate();
  return (
    <div className="App">
      <Navbar style={{ padding: "1rem", color: "aqua" }} />

      <Routes>
        <Route path="/" element={<Kids />} />
        <Route path="/inscrieri/greenkids" element={<Kids />} />
        <Route path="/cursasponsorilor" element={<UserLogin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/login" element={<UserLogin />}></Route>
        <Route path="/editmember" element={<EditMember />}>
          <Route path=":id" element={EditMember} />
        </Route>
        <Route path="/edituser" element={<Users />} />
        <Route path="/members" element={<Members />}>
          <Route path=":id" element={<EditMember />} />
        </Route>
        <Route path="/finish" element={<Finish />} />

        <Route
          path="*"
          element={
            <main style={{ padding: "1rem", color: "aqua" }}>
              <p>Error 404: Pagina nu exista</p>

              <Button
                variant="outlined"
                type="button"
                onClick={() => {
                  returnHome("/");
                }}
              >
                Acasa
              </Button>
            </main>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
